import { UmbrellaOrgMembership, UmbrellaSettingsRsp } from '@fullstory/proto/fs/api/clientapi';
import { RequestActionType } from '@fullstory/redux-util';
import { SettingsTypes } from '../types';
import { UmbrellaSettingsRequestActions } from './actions';

export const umbrellaReducer = (
  state: UmbrellaSettingsRsp | null = null,
  action: RequestActionType<typeof UmbrellaSettingsRequestActions>,
): UmbrellaSettingsRsp | null => {
  switch (action.type) {
    case SettingsTypes.UmbrellaSettingsSuccess:
      return action.data;
    case SettingsTypes.UmbrellaManagerSuccess:
    case SettingsTypes.UmbrellaUpdateSeatsSuccess: {
      const request = action.request.body;
      if (!request || !state) return state;
      // All the updates that were sent to the backend. This is a map of orgName => new role
      const updatedMemberships = request.Updates;
      if (!updatedMemberships) return state;

      // The 'seat' (aka user) that needs updating
      const updatedSeat = state.seats.find(s => s.email === request.Email);
      if (!updatedSeat) return state;

      // Get all orgNames in the umbrella for use when updating UmbrellaOrgMembership array
      const orgNames = state.orgs.reduce(
        (acc, val) => acc.set(val.orgId, val.name),
        new Map<string, string>(),
      );

      // For each 'update' sent to backend, create a UmbrellaOrgMembership object and append to new array
      const newSeats = updatedMemberships.reduce<UmbrellaOrgMembership[]>((acc, update) => {
        const orgName = orgNames.get(update?.OrgId ?? '');
        if (update && orgName) return [...acc, { orgId: update.OrgId, orgName, role: update.Role }];
        return acc;
      }, []);

      // Replace the seat's (user's) membership information with updated memberships
      const newState = { ...state, seats: [...state.seats] };
      newState.seats[state.seats.indexOf(updatedSeat)] = { ...updatedSeat, seats: newSeats };
      return newState;
    }
  }
  return state;
};
